import React from 'react'
import { Card, Icon } from 'semantic-ui-react';

import CardData from 'draft/cards/cards.json'
import { ShopCard } from 'draft/types';

type CardProps = {
    name: string,
    cost: string,
    description: string,
    frequency? : number;
}

const CardComponent = ({ name, cost, description, frequency }: CardProps) => (
    <Card className={"shop card-body"}>
        <Card.Content>
            <Card.Header className={'card-text'}>{name}</Card.Header>
            <Card.Meta className={'card-text-yellow'}><Icon name='beer' />{cost}</Card.Meta>
            <Card.Description className={'card-text'}>
                {description}
            </Card.Description>
        </Card.Content>
        <Card.Content extra style={{color:'white'}}>
            <h4>{frequency && frequency > 1 && `${frequency}x`}</h4>
        </Card.Content>
    </Card>
)

const CardsShowcase = () => {
    const cardObj = Object(CardData);
    const cards: ShopCard[] = []

    Object.values(cardObj).forEach((sh: any, i) => {
        var tempCard: ShopCard = {
            Index: i,
            Name: sh['Name'],
            Description: sh['Description'],
            Cost: sh['Cost'],
            Frequency: sh['Frequency']
        }
        if (tempCard.Frequency && tempCard.Frequency > 0)
            cards.push(tempCard);
    })

    return (
        <div style={{ textAlign: 'left' }}>
            <h1>Cards</h1>
            <Card.Group centered itemsPerRow={3}>
                {cards.map(c => (
                    <CardComponent name={c.Name} cost={c.Cost} description={c.Description} frequency={c.Frequency} />
                ))}
            </Card.Group>
        </div>
    )
}

export default CardsShowcase;